import React from "react";
import { Repeat } from "lucide-react";
import { money } from "@/lib/financeApi";

/** Money that moved between buckets inside the program (statement Section 3) — kept out of Money in / out. */
export function InternalCard({ items = [], total = 0, prev = 0, per, note }) {
  const diff = total - prev;
  return (
    <section data-testid="flow-internal" className="p-5 rounded-md border border-sky-400/20 bg-sky-500/[0.03] space-y-3">
      <div className="flex flex-wrap items-center gap-2">
        <Repeat className="h-4 w-4 text-sky-300" /><span className="text-nex-silver font-semibold flex-1">Internal moves · no cash crossed the program</span>
        <span className="font-mono text-lg text-sky-200" data-testid="flow-internal-total">{money(total)}</span>
        {prev != null && <span className="text-[11px] text-nex-muted w-full sm:w-auto">{diff === 0 ? `Same as last ${per}` : `${diff > 0 ? "▲" : "▼"} ${money(Math.abs(diff))} vs last ${per}`}</span>}
      </div>
      <div className="grid gap-x-6 gap-y-2 grid-cols-2 lg:grid-cols-3 xl:grid-cols-5">
        {items.map((x) => (
          <div key={x.key} data-testid={`flow-internal-${x.key}`} className={x.amount ? "" : "opacity-40"}>
            <div className="nds-label-dim text-[9px]">{x.label}</div><div className="font-mono text-sm text-nex-silver">{money(x.amount)}</div>
            {note && /rent withheld|case management/i.test(x.label) && <div className="text-[9px] text-nex-muted" data-testid={`flow-internal-wait-${x.key}`}>includes pay still waiting on vendor</div>}
          </div>))}
      </div>
    </section>
  );
}
